export default __webpack_public_path__ + "static/media/logo-rocketleague.c61d5917.png";